import axiosService from 'services/axiosService';
import { DOMAIN } from 'constants';

const url = 'api/v2/sitemaps';

export const getSiteMap = () => {
  return axiosService.get(`${DOMAIN}/${url}`);
};
